document.addEventListener("DOMContentLoaded", function () {
  const startSurveyButton = document.getElementById("startSurvey");
  const surveyForm = document.getElementById("survey-form");
  const surveyQuestions = document.querySelectorAll(".surveyQuestion");
  const initialTitle = document.querySelector(".initialTitle");
  const initialParagraph = document.querySelector(".initialParagraph");
  const stepsProgress = document.querySelector(".steps-progress");
  const stepsProgressWrapper = document.querySelector(".steps-progress-wrapper");
  const progressText = document.querySelector(".progress-text");

  const progressIncrement = 100 / surveyQuestions.length;
  let progressWidth = 0;
  let currentQuestionIndex = 0;

      const markQuestionAsValidated = (question) => {
        if (question) {
            question.classList.add('validated');
        }
    };

    const handleOtherOptionSelection = (inputElement) => {
        const surveyQuestion = inputElement.closest('.surveyQuestion');
        if (surveyQuestion) {
            const otherTextInput = surveyQuestion.querySelector('.otherTextInput');
            const textArea = otherTextInput ? otherTextInput.querySelector('textarea') : null;

            if (inputElement.type === "checkbox") {
                if (inputElement.classList.contains('otherOption') && inputElement.checked) {
                    if (otherTextInput) otherTextInput.style.display = 'block';
                } else if (!surveyQuestion.querySelector('.otherOption:checked')) {
                    if (otherTextInput) {
                        otherTextInput.style.display = 'none';
                        if (textArea) textArea.value = '';
                    }
                }
            } else if (inputElement.type === "radio") {
                if (inputElement.classList.contains('otherOption') && inputElement.checked) {
                    if (otherTextInput) otherTextInput.style.display = 'block';
                } else {
                    if (otherTextInput) {
                        otherTextInput.style.display = 'none';
                        if (textArea) textArea.value = '';
                    }
                }
            }
            markQuestionAsValidated(surveyQuestion);
        }
    };

  const validateQuestion9 = () => {
    const question9 = document.getElementById('surveyQ4');
    if (!question9.classList.contains('requires-validation')) {
        return true;
    }

    // IDs corrected based on your HTML
    const select1 = document.getElementById('4ApreferredPricePoints');
    const select2 = document.getElementById('4BPreferredPriceStart');
    
    // Check if the skip radio button is checked
    const skipQuestion = question9.querySelector('input[type="radio"][name="04ApreferredPricePoints"][value="Skip"]').checked;
    
    if (skipQuestion) return true;

    // Validate if both dropdowns have a selected option that is not the placeholder
    if (select1.selectedIndex <= 0 || select2.selectedIndex <= 0) { // 0 would be the disabled placeholder option
        question9.querySelector('.errormessage').innerHTML = 'Please select both price points.';
        return false;
    }

    // Optionally, you might want to ensure the second price is greater than the first
    const price1 = parseInt(select1.options[select1.selectedIndex].value.replace(/[^\d.]/g, ''), 10);
    const price2 = parseInt(select2.options[select2.selectedIndex].value.replace(/[^\d.]/g, ''), 10);
    
    if (price2 <= price1) {
        question9.querySelector('.errormessage').innerHTML = 'The second price should be greater than the first price.';
        return false;
    }

    return true;
};

      const validateSelectsBasic = () => {
        const question9 = document.getElementById('surveyQ4');
        const select1 = document.getElementById('4ApreferredPricePoints');
        const select2 = document.getElementById('4BPreferredPriceStart');

        // Basic check: If both selects have a non-placeholder value, mark as validated
        if (select1.selectedIndex > 0 && select2.selectedIndex > 0) {
            markQuestionAsValidated(question9);
        } else {
            question9.classList.remove('validated');
        }
    };
  

    // Add basic validation event listeners to the dropdowns in question 9
    const select1 = document.getElementById('4ApreferredPricePoints');
    const select2 = document.getElementById('4BPreferredPriceStart');

    select1.addEventListener('change', validateSelectsBasic);
    select2.addEventListener('change', validateSelectsBasic);
  
    const textareas = document.querySelectorAll('#surveyQ10 textarea, #surveyQ12 textarea');
    textareas.forEach(textarea => {
        textarea.addEventListener('input', () => {
            // Trigger validation check when textarea content changes
            isCurrentQuestionAnswered();
        });
    });


// Select all radio buttons and checkboxes within any '.surveyQuestion' container
const allSurveyQuestionOptions = document.querySelectorAll('.surveyQuestion .custom-radio input[type="radio"], .surveyQuestion .custom-checkbox input[type="checkbox"]');

// Add a change event listener to each radio button and checkbox
allSurveyQuestionOptions.forEach(option => {
    option.addEventListener('change', function() {
        handleOtherOptionSelection(this);
    });
});

      // Event listener for the age select dropdown in surveyQ13
    const ageSelect = document.getElementById('Age');
    ageSelect.addEventListener('change', () => {
        isCurrentQuestionAnswered();
    });
  
const isCurrentQuestionAnswered = () => {
    const currentQuestion = surveyQuestions[currentQuestionIndex];
    let isAnswered = false;

    // Additional check for textarea in surveyQ10 and surveyQ12
    if (currentQuestion.id === 'surveyQ10' || currentQuestion.id === 'surveyQ12') {
        const textarea = currentQuestion.querySelector('textarea');
        const skipRadio = currentQuestion.querySelector('input[type="radio"][value="Skip"]').checked;

        if (skipRadio || (textarea && textarea.value.trim() !== "")) {
            markQuestionAsValidated(currentQuestion);
            isAnswered = true;
        } else {
            currentQuestion.classList.remove('validated');
        }
    } else if (currentQuestion.id === 'surveyQ13') {
        // Additional check for the age select in surveyQ13
        const ageSelect = currentQuestion.querySelector('#Age');
        const skipRadio = currentQuestion.querySelector('input[type="radio"][value="Skip"]').checked;

        if (skipRadio || (ageSelect && ageSelect.selectedIndex > 0)) {
            markQuestionAsValidated(currentQuestion);
            isAnswered = true;
        } else {
            currentQuestion.classList.remove('validated');
        }
    } else if (currentQuestionIndex === 8) {
        // Existing check for surveyQ9
        isAnswered = validateQuestion9();
    } else if (!currentQuestion.classList.contains('requires-validation')) {
        isAnswered = true;
    } else {
        // Check for other questions
        const inputs = currentQuestion.querySelectorAll('input[type="radio"], input[type="checkbox"], textarea, select');
        isAnswered = Array.from(inputs).some(input => {
            if (input.type === "textarea") {
                return input.value.trim() !== "";
            } else if (input.tagName === "SELECT") {
                return !input.options[input.selectedIndex].disabled;
            }
            return input.checked;
        });
    }

    if (isAnswered) {
        markQuestionAsValidated(currentQuestion);
    } else {
        currentQuestion.classList.remove('validated');
    }

         if (currentQuestion.id === 'surveyQ13') {
            const skipRadio = currentQuestion.querySelector('input[type="radio"][value="Skip"]').checked;

            if (skipRadio || ageSelect.selectedIndex > 0) {
                markQuestionAsValidated(currentQuestion);
                isAnswered = true;
            } else {
                currentQuestion.classList.remove('validated');
            }
        }

    return isAnswered;
};



  const clearErrorMessages = () => {
    document.querySelectorAll('.errormessage').forEach(elem => {
      elem.innerHTML = '';
    });
  };

  const showNextQuestion = () => {
    clearErrorMessages();

    if (!isCurrentQuestionAnswered() && surveyQuestions[currentQuestionIndex].classList.contains('requires-validation')) {
      const errorMessageElement = surveyQuestions[currentQuestionIndex].querySelector('.errormessage');
      if (errorMessageElement) {
        errorMessageElement.innerHTML = "Please provide a response to continue.";
        return;
      }
    }

    surveyQuestions[currentQuestionIndex].style.display = "none";
    currentQuestionIndex++;
    if (currentQuestionIndex < surveyQuestions.length) {
      surveyQuestions[currentQuestionIndex].style.display = "block";
    }
    progressWidth += progressIncrement;
    stepsProgress.style.width = `${progressWidth}%`;
    progressText.innerText = `${Math.round(progressWidth)}% complete`; // Added this line
  };

  startSurveyButton.addEventListener("click", function () {
    this.style.display = "none";
    initialTitle.style.display = "none";
    initialParagraph.style.display = "none";
    surveyQuestions[currentQuestionIndex].style.display = "block";
    stepsProgress.style.display = "flex";
    stepsProgressWrapper.classList.add("active-steps");
    progressWidth += progressIncrement;
    stepsProgress.style.width = `${progressWidth}%`;
    progressText.innerText = `${Math.round(progressWidth)}% complete`; // Added this line
  });

surveyQuestions.forEach((question, index) => {
    const nextButton = question.querySelector(".next-btn");
    nextButton.addEventListener("click", function (event) {
        event.preventDefault();

        // Check if the current question is question 9
        if (index === 8) { // Assuming question 9 is at index 8 in your surveyQuestions array
            if (!validateQuestion9()) {
                // If validateQuestion9 returns false, stop the function to prevent moving to the next question
                return;
            }
        }

        // Proceed to show the next question if it's not the last question
        if (currentQuestionIndex < surveyQuestions.length - 1) {
            showNextQuestion();
        } else {
            // submitSurvey function needs to be defined or implemented here
        }
    });
});

});



document.addEventListener("DOMContentLoaded", function () {
    const stepsProgressWrapper = document.querySelector(".steps-progress-wrapper");
    const surveyForm = document.getElementById("survey-form");

// Adding validation on the final submit button click
const finalSubmitButton = document.getElementById("finalSubmit");
finalSubmitButton.addEventListener("click", function (event) {
    const ageSelect = document.getElementById("Age");
    const skipRadio = document.querySelector("#surveyQ13 input[type='radio'][value='Skip']");

    // Validate only if the skip button is not checked
    if (!skipRadio.checked && ageSelect.options[ageSelect.selectedIndex].disabled) {
        event.preventDefault();
        document.querySelector("#surveyQ13 .errormessage").innerHTML = "Please provide a response to continue.";
    }
});


    surveyForm.addEventListener("submit", function (event) {
        event.preventDefault(); // Prevents the form from submitting the traditional way

        let formDataObj = {};
        new FormData(surveyForm).forEach((value, key) => {
            if (!Array.isArray(formDataObj[key])) {
                formDataObj[key] = [];
            }
            formDataObj[key].push(value);
        });

        // Resetting checkbox values in formDataObj
        document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            formDataObj[checkbox.name] = [];
        });

        // Adding checked values only
        document.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
            formDataObj[checkbox.name].push(checkbox.value);
        });

        fetch(surveyForm.action, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formDataObj),
        })
        .then(response => {
            if (response.ok) {
                stepsProgressWrapper.classList.add("complete");
                const thankYouParagraph = document.createElement("p");
                thankYouParagraph.innerHTML = "Thank you! Here's your 15% off coupon: <strong>VAPESURVEY15.</strong> Expiry date 1st Feb 2024 23.59";
                thankYouParagraph.className = "successful-survey-thankyou";
                stepsProgressWrapper.insertAdjacentElement("afterend", thankYouParagraph);
                surveyForm.classList.add("completedForm");
            } else {
                alert("Error submitting survey.");
            }
        })
        .catch(error => {
            alert("Network error occurred.");
        });
    });
});